function setPageTitle(pageTitle) {
    if (pageTitle && pageTitle != "")
        document.title = "ISA | " + pageTitle;
    else
        document.title = "Information Security Awareness";
}
export default setPageTitle;